import { authFetch } from "./authFetch";
import { BACKEND_URL } from "lib/utils/baseUrl";

const toYmd = (value) => {
  if (!value) return "";
  if (typeof value === "string") return value;
  if (!(value instanceof Date)) return "";
  const year = value.getFullYear();
  const month = String(value.getMonth() + 1).padStart(2, "0");
  const day = String(value.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export async function getAdminProjects(query = {}) {
  const qs = new URLSearchParams();
  qs.set("searchField", query.searchField || "all");
  qs.set("userFilter", query.userFilter || "all");
  qs.set("teamFilter", query.teamFilter || "all");
  qs.set("sortKey", query.sortKey || "createdAt");
  qs.set("sortDir", String(query.sortDir).toUpperCase() === "ASC" ? "ASC" : "DESC");
  qs.set("page", String(Math.max(1, Number(query.page) || 1)));
  qs.set("limit", String(Math.max(10, Number(query.limit) || 20)));

  const keyword = String(query.keyword ?? "").trim();
  if (keyword) qs.set("keyword", keyword);

  const startDate = toYmd(query.startDate);
  const endDate = toYmd(query.endDate);
  if (startDate) qs.set("startDate", startDate);
  if (endDate) qs.set("endDate", endDate);

  const response = await authFetch(
    `${BACKEND_URL}/admin/projects?${qs.toString()}`,
    { method: "GET" },
    { refreshUrlIncludes: "auth/refresh" },
  );

  const result = await response.json().catch(() => null);

  if (!response.ok || result?.success !== true) {
    return {
      success: false,
      message: result?.message || "프로젝트 목록 조회 실패",
      rows: [],
      totalCount: 0,
      pagination: {
        currentPage: Number(query.page) || 1,
        totalPages: 1,
        limit: Number(query.limit) || 20,
      },
      sort: {
        sortKey: query.sortKey || "createdAt",
        sortDir: query.sortDir || "DESC",
      },
      filterOptions: { users: [], teams: [] },
    };
  }

  const data = result?.data ?? {};
  return {
    success: true,
    message: result?.message || "프로젝트 목록을 불러왔습니다.",
    rows: Array.isArray(data.rows) ? data.rows : [],
    totalCount: Number(data.totalCount ?? 0),
    pagination: {
      currentPage: Number(data.pagination?.currentPage ?? query.page ?? 1),
      totalPages: Number(data.pagination?.totalPages ?? 1),
      limit: Number(data.pagination?.limit ?? query.limit ?? 20),
    },
    sort: data.sort ?? {
      sortKey: query.sortKey || "createdAt",
      sortDir: query.sortDir || "DESC",
    },
    filterOptions: {
      users: Array.isArray(data.filterOptions?.users)
        ? data.filterOptions.users
        : [],
      teams: Array.isArray(data.filterOptions?.teams)
        ? data.filterOptions.teams
        : [],
    },
  };
}
